module.exports = __webpack_public_path__ + "img/ask-popup-bg.bc090005.png";